module.exports = __webpack_public_path__ + "static/media/our-values-awards-2.57123c7c.png";